import Component from '@glimmer/component';

export default class FormProgressComponent extends Component {
  get segments() {
    const steps = this.args.steps ?? [];
    const current = this.args.currentStep ?? 0;
    return steps.map((name, i) => ({
      name,
      done: i < current,
      active: i === current,
    }));
  }
}
